import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  assignPaymentInstruction,
  fetchAssignmentCustomers,
} from "../../../services/paymentInstructionService";

export const fetchAssignmentCustomersAsync = createAsyncThunk(
  "paymentInstruction/fetchCustomers",
  async (filter, { rejectWithValue }) => {
    try {
      return await fetchAssignmentCustomers(filter);
    } catch (error) {
      return rejectWithValue(error.response?.data || "Failed to load customers");
    }
  }
);

export const assignPaymentInstructionAsync = createAsyncThunk(
  "paymentInstruction/assign",
  async (
    { customerIds, jkBankAccountId, sendEmail, connectionId } = {},
    { rejectWithValue }
  ) => {
    try {
      return await assignPaymentInstruction({
        customerIds,
        jkBankAccountId,
        sendEmail,
        connectionId,
      });
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
          error.message ||
          "Failed to assign payment accounts"
      );
    }
  }
);

const paymentInstructionSlice = createSlice({
  name: "paymentInstruction",
  initialState: {
    customers: [],
    total: 0,
    page: 1,
    pageSize: 50,
    loading: false,
    error: null,
    lastAssignResult: null,
  },
  reducers: {
    clearAssignResult: (state) => {
      state.lastAssignResult = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAssignmentCustomersAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAssignmentCustomersAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.customers = action.payload?.items || [];
        state.total = action.payload?.total || 0;
        state.page = action.payload?.page || 1;
        state.pageSize = action.payload?.pageSize || 50;
      })
      .addCase(fetchAssignmentCustomersAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(assignPaymentInstructionAsync.fulfilled, (state, action) => {
        state.lastAssignResult = action.payload;
      })
      .addCase(assignPaymentInstructionAsync.rejected, (state, action) => {
        state.error = action.payload;
      });
  },
});

export const { clearAssignResult } = paymentInstructionSlice.actions;
export default paymentInstructionSlice.reducer;
